import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterGuards } from './guards'

// Combined route table during the transition: new routes + the legacy routes
// served unchanged from src_old. Keep exactly ONE catch-all, last.
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  // Legacy behavior kept: every navigation scrolls to top (ada-app-ui has no
  // scrollBehavior, but this portal is mobile-heavy with long debt lists).
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    // Dev-only sandbox — registered only in dev builds so it never enters the
    // production bundle.
    ...(import.meta.env.DEV
      ? [
          {
            name: 'Dev',
            path: '/dev',
            meta: { public: true },
            component: () => import('@/views/DevPlayground/DevPlayground.vue'),
          },
        ]
      : []),

    // Legacy routes (unchanged views from src_old)
    { name: 'Home', path: '/', component: () => import('@old/views/Home.vue') },
    {
      name: 'Authenticate',
      path: '/authenticate',
      meta: { public: true },
      component: () => import('@old/views/Authenticate.vue'),
    },
    { name: 'Profile', path: '/profile', component: () => import('@old/views/Profile.vue') },
    { name: 'DebtSummary', path: '/summary', component: () => import('@old/views/Summary.vue') },
    { name: 'Support', path: '/support', component: () => import('@old/views/Support.vue') },
    {
      name: 'TicketView',
      path: '/support/:ticket_id',
      props: true,
      component: () => import('@old/views/TicketView.vue'),
    },
    { name: 'AboutSite', path: '/om-webbplatsen', component: () => import('@old/views/AboutSite.vue') },
    { name: 'OCR', path: '/ocr/:ocr', redirect: '/' },

    // Greedy single-segment param — matches any top-level path not claimed by a
    // static route (legacy debt deep-links)
    { name: 'Debt', path: '/:debt_id', props: true, component: () => import('@old/views/Debt.vue') },

    { name: 'PageNotFound', path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

setupRouterGuards(router)

export default router
